import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';

const style = {
    'fontFamily': 'Roboto',
    'fontStyle': 'normal',
    'fontWeight': '700',
    'fontSize': '14px',
    'lineHeight': '20px',
    'color': '#3F3F3F'
}

const iconStyle = {
    'color': '#FF0000',
    'margin': '5px 10px'
}

const ErrorToast = () => {

    return (
        <Alert severity='error' icon={ <CheckCircleOutline style={iconStyle}/> } sx={{backgroundColor: '#F3DBD9'}}>
            <AlertTitle sx={style}>Usuario y/o contraseña incorrectos</AlertTitle>
        </Alert>
    )
}

export default ErrorToast